import React, { useState } from 'react';
import { Box } from '@mui/material';

import { VideoInterviewPlayer } from 'components/common/VideoInterviewPlayer/VideoInterviewPlayer';

const LANDSCAPE_RATIO = 4 / 3;
const PORTRAIT_HEIGHT = { xs: 220, tablet: 432 };

export const VideoIntro: React.FC<{ fileName: string }> = ({ fileName }) => {
  const [ratio, setRatio] = useState<number | null>(null);
  const clip = ratio ?? LANDSCAPE_RATIO;
  const portrait = clip < 1;

  return (
    <Box
      sx={{
        display: 'grid',
        placeItems: 'center',
        width: '100%',
        borderRadius: 1,
        overflow: 'hidden',
        backgroundColor: 'background.mediaFrame',
        ...(portrait
          ? { height: PORTRAIT_HEIGHT }
          : { aspectRatio: String(Math.max(clip, LANDSCAPE_RATIO)) }),
      }}
    >
      <Box
        sx={{
          height: '100%',
          maxWidth: '100%',
          aspectRatio: String(clip),
          borderRadius: 1,
          overflow: 'hidden',
          background: 'black',
        }}
      >
        <VideoInterviewPlayer
          fileName={fileName}
          playing={false}
          onAspectRatio={setRatio}
        />
      </Box>
    </Box>
  );
};
